export function isEditMode(): boolean {
  return window.location.pathname.endsWith('/edit')
}

/** By path alone: anything heavier here would close an import cycle via redux/pubsub */
export function isDebugOrEditMode(): boolean {
  return /\/(edit|debug)$/.test(window.location.pathname)
}
